import { doc, setDoc, increment, serverTimestamp } from 'firebase/firestore';
import { database } from '../firebaseConfig';

const VISIT_FLAG = 'prepify_visit_tracked';

export const trackSiteVisit = async () => {
  if (typeof window === 'undefined' || typeof sessionStorage === 'undefined') return;
  if (sessionStorage.getItem(VISIT_FLAG)) return;

  sessionStorage.setItem(VISIT_FLAG, 'true');

  try {
    const metricsRef = doc(database, 'metrics', 'global');
    await setDoc(
      metricsRef,
      {
        totalVisits: increment(1),
        lastVisitAt: serverTimestamp(),
      },
      { merge: true }
    );
  } catch (error) {
    console.error('Failed to record site visit:', error);
    sessionStorage.removeItem(VISIT_FLAG);
  }
};

